import * as React from 'react'

import { observer } from 'mobx-react'

import {
  CardListSummaryBar,
  ICardListItem,
  ICardListState,
} from '~/client/src/shared/components/CardList'
import { ListHeader } from '~/client/src/shared/components/ListHeader'
import {
  Empty,
  EmptyHeader,
  EmptyTitle,
} from '~/client/src/shared/components/shadcn-ui/empty'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { PickerScrollRoot } from './IconPickerGrid'
import { IconPickerTileTooltip } from './IconPickerTile'

interface IProps<T extends ICardListItem> {
  query: string
  onQueryChange: (query: string) => void
  count: number
  countLabel?: string
  listState?: ICardListState<T>
  children: React.ReactNode
}

function IconPickerPanel<T extends ICardListItem>({
  query,
  onQueryChange,
  count,
  countLabel,
  listState,
  children,
}: IProps<T>): React.ReactElement {
  const t = Localization.translator
  const [scrollRoot, setScrollRoot] = React.useState<HTMLDivElement | null>(
    null,
  )

  return (
    <div className="tw:flex tw:min-h-0 tw:flex-1 tw:flex-col">
      <ListHeader.DisplayBar
        search={{
          value: query,
          onChange: onQueryChange,
          placeholder: t.search,
        }}
      />
      <CardListSummaryBar listState={listState}>
        {countLabel ?? t.iconPicker.xIcons(count)}
      </CardListSummaryBar>
      {/* the grid owns pan-y, so vaul must not read a flick as swipe-to-dismiss */}
      <div
        ref={setScrollRoot}
        data-vaul-no-drag=""
        className="tw:min-h-0 tw:flex-1 tw:overflow-y-auto"
      >
        {count > 0 ? (
          <PickerScrollRoot.Provider value={scrollRoot}>
            <IconPickerTileTooltip>{children}</IconPickerTileTooltip>
          </PickerScrollRoot.Provider>
        ) : (
          <Empty>
            <EmptyHeader>
              <EmptyTitle>{t.iconPicker.noResults}</EmptyTitle>
            </EmptyHeader>
          </Empty>
        )}
      </div>
    </div>
  )
}

export default observer(IconPickerPanel)
